import script from "./FunctionSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./FunctionSelector.vue?vue&type=script&setup=true&lang=ts"

import "./FunctionSelector.vue?vue&type=style&index=0&id=b3579f1e&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3579f1e"]])

export default __exports__